var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.954,
    height: 23
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-help_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M0 0h22.954v23H0z",
    "data-name": "Rectangle 842"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon - Support"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#icon-help_svg__a)",
    "data-name": "Group 1696"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.915 9.66a8.54 8.54 0 0117.059-.808c.013.268.013.538 0 .808",
    "data-name": "Path 5122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.731 17.511a8.519 8.519 0 01-5.575 3.471",
    "data-name": "Path 5123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.525 15.197a2.16 2.16 0 01-1.808 2.457 2.151 2.151 0 01-2.42-1.807l-.553-3.71a2.14 2.14 0 011.773-2.454h.022a2.153 2.153 0 012.422 1.832z",
    "data-name": "Path 5124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.422 15.196a2.142 2.142 0 004.188.9 2.522 2.522 0 00.039-.254l.554-3.709a2.134 2.134 0 10-4.2-.759 4.92 4.92 0 00-.02.136z",
    "data-name": "Path 5125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.445 18.707a1.788 1.788 0 11-1.779 1.789 1.783 1.783 0 011.779-1.789z",
    "data-name": "Path 5126"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMi45NTQiIGhlaWdodD0iMjMiPjxkZWZzPjxjbGlwUGF0aCBpZD0iYSI+PHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS41IiBkPSJNMCAwaDIyLjk1NHYyM0gweiIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgODQyIi8+PC9jbGlwUGF0aD48L2RlZnM+PGcgZGF0YS1uYW1lPSJJY29uIC0gU3VwcG9ydCI+PGcgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxLjUiIGNsaXAtcGF0aD0idXJsKCNhKSIgZGF0YS1uYW1lPSJHcm91cCAxNjk2Ij48cGF0aCBkPSJNMi45MTUgOS42NmE4LjU0IDguNTQgMCAwIDEgMTcuMDU5LS44MDhjLjAxMy4yNjguMDEzLjUzOCAwIC44MDgiIGRhdGEtbmFtZT0iUGF0aCA1MTIyIi8+PHBhdGggZD0iTTE4LjczMSAxNy41MTFhOC41MTkgOC41MTkgMCAwIDEtNS41NzUgMy40NzEiIGRhdGEtbmFtZT0iUGF0aCA1MTIzIi8+PHBhdGggZD0iTTUuNTI1IDE1LjE5N2EyLjE2IDIuMTYgMCAwIDEtMS44MDggMi40NTcgMi4xNTEgMi4xNTEgMCAwIDEtMi40Mi0xLjgwN2wtLjU1My0zLjcxYTIuMTQgMi4xNCAwIDAgMSAxLjc3My0yLjQ1NGguMDIyYTIuMTUzIDIuMTUzIDAgMCAxIDIuNDIyIDEuODMyWiIgZGF0YS1uYW1lPSJQYXRoIDUxMjQiLz48cGF0aCBkPSJNMTcuNDIyIDE1LjE5NmEyLjE0MiAyLjE0MiAwIDAgMCA0LjE4OC45IDIuNTIyIDIuNTIyIDAgMCAwIC4wMzktLjI1NGwuNTU0LTMuNzA5YTIuMTM0IDIuMTM0IDAgMSAwLTQuMi0uNzU5IDQuOTIgNC45MiAwIDAgMC0uMDIuMTM2WiIgZGF0YS1uYW1lPSJQYXRoIDUxMjUiLz48cGF0aCBkPSJNMTEuNDQ1IDE4LjcwN2ExLjc4OCAxLjc4OCAwIDEgMS0xLjc3OSAxLjc4OSAxLjc4MyAxLjc4MyAwIDAgMSAxLjc3OS0xLjc4OVoiIGRhdGEtbmFtZT0iUGF0aCA1MTI2Ii8+PC9nPjwvZz48L3N2Zz4K";
export { SvgIconHelp as ReactComponent };